// helper to map API responses to notification payloads
export function mapApiErrorToNotification(payload, status) {
  // payload may be ASP.NET ProblemDetails ({ title, errors, detail })
  // or our API BaseResponse ({ succeeded, statusCode, message, data })
  if (!payload) {
    return { title: `Request failed (${status})`, text: payload?.statusText || 'Unknown error' };
  }

  // If BaseResponse shape
  if (typeof payload === 'object' && payload.hasOwnProperty('message')) {
    const title = payload.message || `Request failed (${payload.statusCode || status})`;
    return { title, text: undefined };
  }

  // If ProblemDetails with errors
  if (payload.errors) {
    const title = payload.title || `Request failed (${payload.status || status})`;
    const errors = [];
    for (const key of Object.keys(payload.errors)) {
      const arr = payload.errors[key];
      if (Array.isArray(arr)) arr.forEach(m => errors.push(`${key}: ${m}`));
    }
    return { title, errors };
  }

  // Fallback: use detail or title
  if (payload.detail || payload.title) {
    return { title: payload.title || `Request failed (${status})`, text: payload.detail || undefined };
  }

  return { title: `Request failed (${status})`, text: JSON.stringify(payload) };
}
